import { Github, Linkedin, Twitter, Mail, Atom } from "lucide-react";

const socialLinks = [
    {
        icon: Linkedin,
        href: "https://linkedin.com/in/ameliadutta",
        label: "LinkedIn",
    },
    {
        icon: Github,
        href: "https://github.com/amelia2802",
        label: "GitHub",
    },
    {
        icon: Twitter,
        href: "https://twitter.com/AmeliaDutta",
        label: "Twitter",
    },
    {
        icon: Mail,
        href: "mailto:amelia.dutta.02@gmail.com",
        label: "Email",
    },
];

const Footer = () => {
    return (
        <footer className="py-12 px-6 bg-background border-t border-border">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="text-center md:text-left">
                        <p className="text-2xl font-bold text-foreground">
                            <a href="#home">Amelia</a><span className="text-primary">.</span>
                        </p>
                        <p className="text-muted-foreground text-sm mt-1">
                            Frontend Software Engineer
                        </p>
                    </div>

                    <div className="flex gap-4">
                        {socialLinks.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-3 bg-secondary rounded-lg hover:bg-primary/10 hover:text-primary transition-all duration-300"
                                aria-label={link.label}
                            >
                                <link.icon className="h-5 w-5" />
                            </a>
                        ))}
                    </div>
                </div>

                <div className="mt-8 pt-8 border-t border-border text-center">
                    <p className="text-muted-foreground text-sm flex items-center justify-center gap-1">
                        Built with <Atom className="h-4 w-4 text-primary" /> by Amelia Dutta
                    </p>
                    <p className="text-muted-foreground/60 text-xs mt-2">
                        © {new Date().getFullYear()} All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
